import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-npspage',
  templateUrl: './npspage.component.html',
  styleUrls: ['./npspage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NpspageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
